export default __webpack_public_path__ + "e62c1972986dcb978691734eb884103a.png";